import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import SimpleBar from "simplebar-react";
import { ArrowLeft, ArrowRight, Trash } from "react-feather";
import { debounce } from 'lodash';
import ConfigDB from "../../Config/ThemeConfig";
import SidebarIcon from "./SidebarIcon";
import { MENU, getSidebarMenus } from "./Menu";
import BackBtn from "./BackBtn";
import SidebarSubMenu from "./SidebarSubMenu";
import CustomizerContext from "../../Helper/Customizer";
import courseContext from "../../Helper/Courses";
import AdminContext from "../../Helper/admin";
import { filterButtonsWithPermissions } from "../../utils/adminRoles";
import QuizContext from "../../Helper/Quiz";
import { Link } from "react-router-dom";
import { Btn } from "../../AbstractElements";

const Sidebar = ({ isQuiz }) => {
  const [isOpen, setIsOpen] = useState([]);
  const { user } = useContext(AdminContext)
  const { activeCourse } = useContext(courseContext)
  const { quiz, setQuestionNo, questionNo, setAddQuiz, deleteQuestion } = useContext(QuizContext)
  const { togglSidebar } = useContext(CustomizerContext);
  const sidebar_types = localStorage.getItem("sidebar_types");
  const wrapper = sidebar_types || ConfigDB.data.settings.sidebar.type;
  const [margin, setMargin] = useState(0);
  const [leftArrow, setLeftArrow] = useState(false);
  const [rightArrow, setRightArrow] = useState(false);
  const [width, setWidth] = useState(0);

  const permissions = user.permissions;
  const isSuperAdmin = user.isSuperAdmin;
  const id = window.location.pathname.split("/").pop();
  const layout = id;

  const handleResize = debounce(() => {
    setWidth(window.innerWidth - 500);
  }, 300);

  useEffect(() => {
    setLeftArrow(true);
  }, []);

  const renderSidebarContent = () => {
    if (isQuiz) {
      return (
        <>
          <Btn attrBtn={{ className: 'w-100', color: "primary", onClick: () => setAddQuiz(true) }}>Add Question</Btn>
          <div className="m-t-40">
            {quiz?.questions?.map((question, index) => (
              <li className={`${'sidebar-link sidebar-title m-t-20 quiz-link'} ${questionNo === index ? 'active-question' : ''}`} onClick={() => setQuestionNo(index)}>
                <Link className={`${"sidebar-link sidebar-title d-flex align-items-center justify-content-between"} `}>
                  <span>
                    Question {index + 1}
                  </span>
                  <Trash  onClick={()=> deleteQuestion(index)}/>
                </Link>
              </li>
            ))}
          </div>
        </>
      );
    } else {
      return filteredMenus.map((item, i) => (
        <Fragment key={i}>
          <li className={item.className}>
            <SidebarSubMenu menu={item.menu} isOpen={isOpen} setIsOpen={setIsOpen} level={0} />
          </li>
        </Fragment>
      ));
    }

  }


  useEffect(() => {
    document.querySelector(".left-arrow").classList.add("d-none");
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [layout]);

  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      if (width === 492) {
        setMargin(-3570);
      } else {
        setMargin(-3464);
      }
      setRightArrow(true);
      setLeftArrow(false);
    } else {
      setLeftArrow(false);
      setMargin((margin) => (margin += -width));
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setLeftArrow(true);
      setRightArrow(false);
    } else {
      setMargin((margin) => (margin += width));
      setRightArrow(false);
    }
  };
  const menus = getSidebarMenus(activeCourse?.id)[0].menu
  const filteredMenus = filterButtonsWithPermissions(menus, permissions, isSuperAdmin)
  return (
    <div className={`sidebar-wrapper ${togglSidebar ? "close_icon" : ""} `} id="sidebar-wrapper">
      <div>
        {!isQuiz && <SidebarIcon />}
        <nav className="sidebar-main">
          <div className={`left-arrow ${leftArrow ? "d-none" : ""}`} id="left-arrow" onClick={scrollToLeft}><ArrowLeft /></div>
          <div
            id="sidebar-menu"
            style={wrapper.split(" ").includes("horizontal-wrapper") ? { marginLeft: margin + "px" } : { margin: "0px" }}>
            <ul className="sidebar-links" style={{ display: "block" }} id="simple-bar">
              <SimpleBar style={{ height: "300px" }}>
                <BackBtn />
                {renderSidebarContent()}
              </SimpleBar>
            </ul>
          </div>
          <div className={`right-arrow ${rightArrow ? "d-none" : ""}`} onClick={scrollToRight}><ArrowRight /></div>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
